import {
  Component,
  OnInit,
  Inject,
  Output,
  EventEmitter,
  Input,
  ElementRef,
  AfterViewInit,
  ViewChild,
  DOCUMENT
} from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { GenericService } from '../../common/common.service';

import DataSource from 'devextreme/data/data_source';
import { environment } from '../../environments/environment';
import {
  PortalMenusView,
  SwitchPortal,
  SystemSetting,
  WebUrlConfig,
} from '../../App.model';
import {
  PortalMenu,
  ChangePasswordUserAction,
  IdentityServerSwitchValue,
} from '../dashboardapp/dashboardapp.model';
import { DashboardService } from '../dashboard/dashboard.service';
import { Router, RouterEvent, NavigationStart, NavigationEnd, ActivatedRoute } from '@angular/router';
declare let $: any;
import * as CryptoJS from 'crypto-js';
import { ConsoleLoggerService } from '../../common/LoggerService/console-logger.service';
import { UtilityService } from '../../common/utility.service';
import dxScrollable from 'devextreme/ui/scroll_view/ui.scrollable';
import { DxTreeViewComponent } from 'devextreme-angular';
import { NotificationComponent } from '../../common/Controls/Notification/notification.component';
import {
  ConfirmationComponent,
  ConfirmationType,
} from '../../common/Controls/Confirmation/confirmation.component';
import { DataService } from '../../common/data.service';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Constants } from '../../common/constants';

@Component({
    selector: 'app-dashboardapp',
    templateUrl: './dashboardapp.component.html',
    styleUrls: ['./dashboardapp.component.css'],
    providers: [
        GenericService,
        DashboardService,
        ConsoleLoggerService,
        UtilityService,
        DataService,
    ],
    standalone: false
})
export class DashboardappComponent implements OnInit, AfterViewInit {
  showSelected: boolean = true;
  dataGrid: DxDataGridComponent;
  ds: DataSource;
  todaydate = new Date();
  public test: Date;
  contacts: any;
  portalmenus: PortalMenusView[];
  public taburls: SwitchPortal[];
  public SystemSettings: SystemSetting[];
  //contacts: any[];o
  contactsDataforGrid: any[] = [];
  private hostname: string;

  private documentURL: string;
  private baseApiURL: string;
  private urlAarray: string[];
  private baseURL: string;

  private errorMessage: any = '';
  __sUserName: string;
  __dLastLoggedInDateTime: any;
  public getApiUrl: string = this.__oUtilityService.GetBasewebAPIURL();
  public releaseVersion: string = '';
  public alertsDataScource: any[] = [];
  public portfolioDataScource: any[] = [];
  public selectedMenu: string;
  public PortalMenus: PortalMenu[];
  @Input() childMessage: number;
  @Output() messageEvent = new EventEmitter<number>();
  public selectedMenuParentId: number;
  __isMainMenuClicked: boolean = false;
  hideDashboardMenu: boolean = false;
  IsLoadingVisible: boolean = false;
  __bUserPreferencesMenu: boolean = false;
  __sBreadCrumbs: string = '';
  __dValuationDateTime: any;
  __lHierarchicalMenuData: PortalMenu[] = [];
  __sPasswordExpiryWarningMessage: string = '';
  __bPasswordChangePopUpButtonVisible: boolean = false;
  __bPasswordChangePopUpVisible: boolean = false;
  __sClientVersion: string = '';
  __sDomain: string = '';
  __sDomainAccount: string = '';
  __sOldPassword: string = '';
  __sNewPassword: string = '';
  __sConfirmPassword: string = '';
  __bIsPopUpLoadingVisible: boolean = false;
  __sPhrase: string = 'Cuuube Looogic19';
  readonly __sMarginCallManagement: string = 'Margin Call Management';
  readonly __sScenarioDetail: string = 'Analysis>Stress Testing';
  currentTheme: string;
  //SSO anonymous access issue FB 18492 VIDYA
  __IsNotAuthorized: boolean = false;
  public __sPortalDateFormat: string;
  __sEnvironment: string = '';
  __sColor: string = '';
  __bMenu: boolean = false;
  __sSelectedItem: string = '';
  __bIsAuthorised: boolean = false;
  @ViewChild('tvMenuPane') __oTrvMenuPane: DxTreeViewComponent;
  __oNotificationComponent: NotificationComponent = null;
  @ViewChild(ConfirmationComponent)
  __oConfirmationComponent: ConfirmationComponent;


  constructor(
    @Inject(DOCUMENT) private document: any,
    public _postDataService: GenericService,
    private router: Router,
    private _dashboardService: DashboardService,
    private _eref: ElementRef,
    private Logger: ConsoleLoggerService,
    private __oUtilityService: UtilityService,
    private data: DataService,
    private cookieService: CookieService,
    private route: ActivatedRoute
  ) {
    this.releaseVersion = '12.0.0.0'; //Version Number should be mentioned here
    this.PortalMenus = [];

    try {
        try {
          this._postDataService.getAuthenticate().pipe(
            catchError((error) => {
              this.__IsNotAuthorized = true;
              this.__bIsAuthorised = false;
              throw Error(error);
            })
          )
            .subscribe(
              data => {

                if (this._postDataService.redirectToUnauthorizePage(data)) {
                  this.__IsNotAuthorized = true;
                  this.router.navigate(['/UnAuthorized/' + data]);
                  return throwError(data);
                }

                this.__sUserName = data;
                sessionStorage.setItem('UserName', this.__sUserName);
                this.__bIsAuthorised = true;

                //--- Start FB 18757 : Sanjaya, 01Oct2020
                var usersession = sessionStorage.getItem('IsUserSession');
                if (usersession != null && usersession != undefined) {
                  if (usersession == 'true') {
                    this.SaveUserSessionData('api/PortalMenu/UserSession');
                    sessionStorage.setItem('IsUserSession', 'false');
                  }
                }
                //--- End FB 18757 : Sanjaya, 01Oct2020
                //Get user last logged in date/time, Commented out becos we are uisng valuation date from system settings
                //FB 18492 SSO Integration Vidya
                this.__IsNotAuthorized = false;
                this.__dLastLoggedInDateTime = new Date();
                this._postDataService
                  .getDataByPromise(
                    this.getApiUrl + 'api/Counterparty/UserSession/' + this.__sUserName
                  )
                  .then((Data) => {
                    if (Data != null) {
                      this.__dLastLoggedInDateTime = new Date(Data);
                    }
                  });
                this._postDataService
                  .getDataByPromise(this.getApiUrl + 'api/PortalMenu/1')
                  .then((Data) => {
                    if (Data != null) {
                      this.portalmenus = Data;
                    }
                  });
                this._postDataService
                  .getDataByPromise(this.getApiUrl + 'api/PortalMenu/SwitchPortal')
                  .then((Data) => {
                    if (Data != null) {
                      this.taburls = Data;
                    }
                  });
                this._postDataService
                  .getDataByPromise(
                    this.getApiUrl + 'api/PortalMenu/GetSystemSetting/1'
                  )
                  .then((Data) => {
                    if (Data != null) {
                      this.SystemSettings = Data;
                      if (this.SystemSettings[0].PortalDateFormat) {
                        sessionStorage.setItem(
                          'PortalDateFormat',
                          this.SystemSettings[0].PortalDateFormat
                        );
                        this.__sPortalDateFormat =
                          this.SystemSettings[0].PortalDateFormat;
                        this.data.setPortalDateFormat(this.__sPortalDateFormat);
                      } else {
                        sessionStorage.setItem('PortalDateFormat', 'dd MMM yyyy');
                        this.__sPortalDateFormat = 'dd MMM yyyy';
                        this.data.setPortalDateFormat(this.__sPortalDateFormat);
                      }

                      this.__dValuationDateTime = new Date(
                        this.SystemSettings[0].ValuationDate
                      );
                      this.__sClientVersion = this.SystemSettings[0].ClientVersion;
                      //this.__bPasswordChangePopUpButtonVisible = this.SystemSettings[0].IsCloudPortal == 0 ? false : true;

                      //FB 6060 hiding the change password option if SSO enabled.
                      this._postDataService
                        .getDataByPromise(this.getApiUrl + 'api/PortalMenu/SSOEnabled')
                        .then((Data) => {
                          if (Data != null) {
                            if (Data == false) {
                              if (this.SystemSettings[0].IsCloudPortal == 1) {
                                //Get Password expiry warning message
                                this._postDataService
                                  .getDataByPromise(
                                    this.getApiUrl + 'api/PortalMenu/GetPasswordExpiry'
                                  )
                                  .then((Data) => {
                                    if (Data != null) {
                                      let ArrData: string[] =
                                        Data.toString().split('\\');

                                      this.__sPasswordExpiryWarningMessage = ArrData[0];
                                      this.__sDomain = ArrData[1];

                                      this.__bPasswordChangePopUpButtonVisible = true;
                                      $('#divDashboardContent .tab-content').css(
                                        'height',
                                        'calc(100vh - 12rem)'
                                      );
                                    }
                                  });
                              } else {
                                this.__bPasswordChangePopUpButtonVisible = false;
                              }
                            } else {
                              this.__bPasswordChangePopUpButtonVisible = false;
                            }
                          }
                        });
                    }
                  });

                // client errors logging into server side functionality - getting flag value - charles

                if (
                  sessionStorage.getItem('EnableServerLoggingForClientError') ==
                  undefined
                ) {
                  this._postDataService
                    .getDataByPromise(
                      this.getApiUrl +
                      'api/PortalMenu/EnableServerLoggingForClientError'
                    )
                    .then((Data) => {
                      if (Data != null) {
                        sessionStorage.setItem(
                          'EnableServerLoggingForClientError',
                          Data
                        );
                      }
                    });
                }

                this._postDataService
                  .getDataByPromise(
                    this.getApiUrl + 'api/PortalMenu/EnvironmentDifferentiate'
                  )
                  .then((Data) => {
                    if (Data != null) {
                      this.__sEnvironment = Data[0];
                      this.__sColor = Data[1];
                    }
                  });

                //Get top level portal menus
                this.loadMainMenu(true);

              }
            );
        } catch (error) {
          this.__bIsAuthorised = false;
          this.router.navigate(['/UnAuthorized/' + error]);
        }


        //FB 24760 Sankar Dhayanithi T., Idle Timeout
        //this.IdleTimeOutOperation();

        // this._postDataService.authenticateUser().subscribe(
        //   data => this.__sUserName = data,
        //   error => {
        //     let err: string = error;
        //     //SSO anonymous access issue FB 18492 VIDYA
        //     this.__IsNotAuthorized = true;
        //     if (err.startsWith("401")) {
        //       this.router.navigate(['/UnAuthorized/' + err]);
        //     }
        //     else {
        //       let errorId = "Error";

        //       this.router.navigate(['/UnAuthorized/' + errorId])
        //     }
        //   },
        //   () => {
        //     //FB 6060 Even user authorization is failed left menu is loading.
        //     if ((this.__sUserName === "Authorization has been denied for this request" || this.__sUserName.indexOf("Authorization has been denied") > -1)||(this.__sUserName === "Authorization has been denied because of Token Expiry" || this.__sUserName.indexOf("Authorization has been denied because of Token Expiry") > -1)) {
        //       this.__IsNotAuthorized = true;
        //       this._postDataService.RedirectToSSOURL(this.__sUserName);//FB 31040 Sankar Dhayanithi T., redirect the user to SSO login URL if unauthorized
        //       this.router.navigate(['/UnAuthorized/' + this.__sUserName]);
        //     }

        //   });

        //For show loading spinner
      (router.events as Observable<RouterEvent>).subscribe((event: RouterEvent) => {
        const matches = this.findMenusByQueryString(this.__lHierarchicalMenuData, event.url);

        this.navigationInterceptor(event, matches);
        });
    } catch (e) {
      this.Logger.Write(e, 'Error', 'constructor_DashboardApp');
    }
  }

  ngOnInit() {
    //if ($('[data-toggle="tooltip"]') != null && $('[data-toggle="tooltip"]') != undefined) {
    //  $('[data-toggle="tooltip"]').tooltip();
    //}
    //For theme base UI Layout
    //this.document.getElementById('theme').href = './StyleSheets/DashBoardManagement/BlueTheme.css';
    //this.currentTheme = 'dark';
    this._postDataService.__bDashboardControlDisplay.subscribe((data) => {
      if(!data){
        this.__bIsAuthorised = false;
        this.__bIsPopUpLoadingVisible = false;
        this.IsLoadingVisible = false;
      }
    });

    this.route.queryParamMap.subscribe(params => {
      this.hideDashboardMenu = params.get('hideDashboardMenu') === 'true';
      if (this.hideDashboardMenu) {
        $('#ScrolltoTop').css({ 'height': 'calc(100vh - 1rem)' });
      } else {
        $('#ScrolltoTop').css({ 'height': 'calc(100vh - 3.3rem)' });
      }
    });
  }

  ngAfterViewInit() { }


  //Switch website method handler
  switchWebSite(cmd: any) {
    if (cmd == 'quit') {
      this._postDataService
        .getDataByObservable(this.getApiUrl + 'api/PortalMenu/SwitchPortal')
        .subscribe((res) => {
          if (res != null) {
            let oTabUrls: SwitchPortal[] = res;
            window.open(oTabUrls[0].UrlSilverLIght, '_blank');
          }
        });
    }
    return false;
  }

  //Load main menus by default
  loadMainMenu(isDefault: boolean) {
    let portalMenu = new PortalMenu();
    portalMenu.lDashBoardPortalMenuId = 0;
    this.loadPortalMenuItems(portalMenu, null);

    if (!isDefault) {
      this.router.navigate(['']);
    }

    this.alertsDataScource = [];
    this.portfolioDataScource = [];
    this.__isMainMenuClicked = true;
    //this.__sBreadCrumbs = '';
    if (this.__bPasswordChangePopUpButtonVisible) {
      $('#divDashboardContent .tab-content').css(
        'height',
        'calc(100vh - 12rem)'
      );
    }
  }

  //load
  //loadPreviousMenu() {
  //  let portalMenu = new PortalMenu();
  //  portalMenu.lDashBoardPortalMenuId = this.selectedMenuParentId;
  //  this.loadPortalMenuItems(portalMenu, null);
  //}

  loadPortalMenuItems(portalMenuGroup: PortalMenu, event: any) {
    //For ASCOT Menu changes
    if (
      portalMenuGroup.QueryString == 'PolicyManagement' ||
      portalMenuGroup.QueryString == 'PolicyCustomerLimitAssesment'
    ) {
      this.routeLink(portalMenuGroup, null);
      if (event != null) {
        event.currentTarget.dataset.target = '#portalMenu';
        event.currentTarget.dataset.toggle = 'collapse';
      }
      return;
    }
    this.IsLoadingVisible = true;
    this.loadHierarchicalMenuData(portalMenuGroup);
  }

  invokeSilverlightScreens(portalMenu: PortalMenu) {
    //this._postDataService.getDataByObservable(this.getApiUrl + "api/PortalMenu/SwitchPortal").subscribe(res => {
    //  if (res != null) {
    //    let oTabUrls: SwitchPortal[] = res;
    //    //if (portalMenu.ParentName == 'Regulatory Risk') {
    //    //  window.open(oTabUrls[0].UrlSilverLIght + "RCPortalFrameWork.aspx", "_blank");
    //    //}
    //    if (portalMenu.DashBoardPortalMenu == 'Exposure Override' || portalMenu.DashBoardPortalMenu == 'Position Management'
    //      || portalMenu.DashBoardPortalMenu == 'Business Process' || portalMenu.DashBoardPortalMenu == 'Workflows' || portalMenu.DashBoardPortalMenu == 'User Profile Settings') {
    //      window.open(oTabUrls[0].UrlSilverLIght + "wfDataCaptureFormSL.aspx?Form=" + portalMenu.QueryString + "", "_blank");
    //    }
    //    else {
    //      window.open(oTabUrls[0].UrlSilverLIght + "wfDataCaptureFormSL.aspx?Form=" + portalMenu.DashBoardPortalMenu + "", "_blank");
    //    }
    //  }
    //});
  }
  //Start Siju FB 22931
  invokeReportUrl(portalMenu: PortalMenu) {
    this._postDataService
      .getDataByObservable(this.getApiUrl + 'api/PortalMenu/WebUrlConfig')
      .subscribe((data) => {
        if (data != null) {
          let oWebUrlConfigs: WebUrlConfig[] = data;
          window.open(
            (oWebUrlConfigs[0].IsHttps ? Constants.HTTPS : Constants.HTTP) + oWebUrlConfigs[0].ReportsUrl + '/Pages/Folder.aspx',
            '_blank'
          );
        }
      });
  }
  //End Siju FB 22931
  invokeAddEntityInstanceScreen() {
    this.router.navigate(['AddCounterparty']);
  }

  invokeDataSearchScreen() {
    this.router.navigate(['DataSearch']);
  }

  changeIcon() {
    if (this.__isMainMenuClicked) {
      let portalMenu = new PortalMenu();
      portalMenu.lDashBoardPortalMenuId = 0;
      this.loadPortalMenuItems(portalMenu, null);
      this.router.navigate(['']);
      this.alertsDataScource = [];
      this.portfolioDataScource = [];
      this.__isMainMenuClicked = false;
    }
  }

  //Invoke/Open a specific screen on basis of selection
  routeLink(menu: PortalMenu, e: any) {
    this.__isMainMenuClicked = false;
    if (
      menu.DashBoardPortalMenu == 'Exposure Override' ||
      menu.DashBoardPortalMenu == 'Cash Pool Management' ||
      menu.DashBoardPortalMenu == 'Group Limit Management' ||
      menu.DashBoardPortalMenu == 'Bank Management' ||
      menu.DashBoardPortalMenu == 'Product Management' ||
      menu.DashBoardPortalMenu == 'Position Management' ||
      menu.ParentName == 'Credit' ||
      //|| (menu.ParentName == 'Enterprise Risk')
      menu.ParentName == 'Regulatory' ||
      //|| (menu.ParentName == 'Static')
      menu.ParentName == 'Treasury' ||
      menu.ParentName == 'User Setup' ||
      //|| (menu.DashBoardPortalMenu.trim() == 'Report Explorer')
      menu.ParentName == 'Financial & Scoring Model' ||
      //|| (menu.ParentName == 'Regulatory Risk')
      menu.ParentName == 'BusinessProcessType' ||
      //|| (menu.DashBoardPortalMenu == 'Workflows')
      menu.DashBoardPortalMenu == 'Reporting Dashboard' ||
      menu.DashBoardPortalMenu == 'Treasury Management' ||
      (menu.DashBoardPortalMenu == 'Country' &&
        menu.ParentName == 'Reference Data Management')
    ) {
      this.invokeSilverlightScreens(menu);
    } else if (menu.DashBoardPortalMenu.trim() == 'Report Explorer') {
      this.invokeReportUrl(menu);
    }
  }

  // Hide/show a user preferences popup on click on user icon
  toggleUserPreferences() {
    this.__bUserPreferencesMenu = !this.__bUserPreferencesMenu;
    this.__dLastLoggedInDateTime = new Date();
  }

  ///Browser window close
  windowClose() {
    //TODO: Make an API call to update loggedout time in database
    let message = Constants.LOGOUT_MESSAGE;
    this.__oConfirmationComponent.show(ConfirmationType.Information,
      message, "Logout", "Logout", "Cancel", true).then(result => {
        if (result) {
          this._postDataService
            .getDataByObservable(this.getApiUrl + 'api/logout')
            .subscribe({
              next: (data) => {
                if (data != null) {
                  this.router.navigate(['/UnAuthorized/logged out successfully']);
                  this.__bIsAuthorised = false;
                }
              },
              error: (error) => {
                if (error.error === 'Authorization has been denied for this request' || error.error.indexOf('Authorization has been denied') > -1 || error.error === 'Authorization has been denied because of Token Expiry' ||
                  error.error === 'Authorization has been denied because of Token not exist') {
                  this.router.navigate([error.error]);
                } else {
                  this.router.navigate(['/UnAuthorized/problem in loggin out']);
                }
              }
            });
        }
      });
  }

  ////Hide user prefeences popup over window on click on document
  //onClick(event: any) {
  //  if (event.target.id != 'accountIcon' && event.target.id != 'accountSpan') {
  //    this.__bUserPreferencesMenu = false;
  //  }
  //  //if (event.target.id.indexOf('menuIconSpan') < 0) {
  //  //  this.__bMenu = false;
  //  //}
  //}

  //Get breadcrumbs to show its navigation
  updateBreadCrums(portalMenu: PortalMenu) {
    this.__sBreadCrumbs = '';
    this.IsLoadingVisible = false;
    this._postDataService
      .getDataByObservable(
        this.getApiUrl +
        'api/PortalMenu/DashBoardPortalmenuHierarchy/' +
        portalMenu.lDashBoardPortalMenuId
      )
      .subscribe((res) => {
        if (res.length > 0) {
          this.__sBreadCrumbs = res
            .map((a) => a.DashBoardPortalMenu)
            .join('> ');
        }
      });
  }

  //Load all its submenus for hierachy form
  loadHierarchicalMenuData(portalMenu: PortalMenu) {
    this.IsLoadingVisible = true;
    this.__lHierarchicalMenuData = [];
    this._postDataService
      .getDataByObservable(
        this.getApiUrl +
        'api/PortalMenu/DashBoardPortalMenuParentChildHierarchy/' +
        portalMenu.lDashBoardPortalMenuId
      )
      .subscribe(
        (res) => {
          this.IsLoadingVisible = false;
          if (res) {
            this.__lHierarchicalMenuData = res;
            sessionStorage.setItem("MenuStorage", JSON.stringify(this.__lHierarchicalMenuData));
          }
        },
        (error) => {
          this.IsLoadingVisible = false;
          console.log(error);
        }
      );
  }

  //Open change password popup
  OpenChangePasswordPopUp() {
    this.__sDomainAccount = this.__sDomain + '\\' + this.__sUserName;
    this.__sOldPassword = '';
    this.__sNewPassword = '';
    this.__sConfirmPassword = '';
    this.__bPasswordChangePopUpVisible = true;
  }

  //Apply button event handler on popup
  PopUpApply() {
    let bValidation: boolean = true;
    let sResponse: string = '';
    this.__bIsPopUpLoadingVisible = true;

    if (
      this.__sOldPassword == null ||
      this.__sOldPassword == '' ||
      this.__sNewPassword == null ||
      this.__sNewPassword == '' ||
      this.__sConfirmPassword == null ||
      this.__sConfirmPassword == ''
    ) {
      bValidation = false;
      sResponse = 'Password field should not be empty.';
    } else if (this.__sNewPassword != this.__sConfirmPassword) {
      bValidation = false;
      sResponse = 'New password and confirm password should be same.';
    }

    let oChangePasswordUserAction: ChangePasswordUserAction =
      new ChangePasswordUserAction();

    const key = CryptoJS.enc.Utf8.parse(this.__sPhrase);
    const iv = CryptoJS.enc.Utf8.parse(this.__sPhrase);

    var oOldPassword = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(this.__sOldPassword),
      key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    var oNewPassword = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(this.__sNewPassword),
      key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    oChangePasswordUserAction.OldPassword = oOldPassword.toString();
    oChangePasswordUserAction.NewPassword = oNewPassword.toString();

    if (bValidation) {
      this._postDataService
        .UpdateAllDataByPromise(
          oChangePasswordUserAction,
          this.getApiUrl + 'api/PortalMenu/ChangeDomainPassword'
        )
        .then((result) => this.OnSuccessSave(result))
        .catch((error) => this.OnError(error));
    } else {
      let widgetOptions = {
        message: sResponse,
        closeOnClick: true,
      };
      this.__oConfirmationComponent.show(
        ConfirmationType.Error,
        sResponse,
        'Error',
        'Ok',
        '',
        false
      );

      this.__bIsPopUpLoadingVisible = false;
    }
  }

  //On error method handler
  private OnError(error: any) {
    if (error != null) {
      let widgetOptions = {
        message: error,
        closeOnClick: true,
      };
      this.__oConfirmationComponent.show(
        ConfirmationType.Error,
        error,
        'Error',
        'Ok',
        '',
        false
      );
    }

    this.__bIsPopUpLoadingVisible = false;
    this.__bPasswordChangePopUpVisible = false;
  }

  //On success save method handler
  private OnSuccessSave(response: any) {
    if (response != null) {
      var oResponse: string = response;

      if (oResponse == 'Success') {
        let widgetOptions = {
          message: 'Password updated successfully',
          closeOnClick: true,
        };

        this.__oConfirmationComponent.show(
          ConfirmationType.Success,
          'Password updated successfully',
          'Success',
          'Ok',
          '',
          false
        );
      } else {
        let widgetOptions = {
          message: oResponse,
          closeOnClick: true,
        };
        this.__oConfirmationComponent.show(
          ConfirmationType.Error,
          oResponse,
          'Error',
          'Ok',
          '',
          false
        );
      }
    }

    this.__bIsPopUpLoadingVisible = false;
    this.__bPasswordChangePopUpVisible = false;
  }

  //Item click handler
  ItemClicked(e: any) {
    if (e.node.expanded) {
      e.component.collapseItem(e.node.key);
    } else {
      e.component.expandItem(e.node.key);
    }
  }

  //On main menu item click handler
  onClickMainMenuItem(type: string) {
    if (
      type == 'Counterparty Management' &&
      this.router.url.indexOf('CounterpartyManagement') == -1
    ) {
      this.__bIsPopUpLoadingVisible = true;
    }

    if (
      type == 'Credit Application' &&
      this.router.url.indexOf('CreditApplication') == -1
    ) {
      this.__bIsPopUpLoadingVisible = true;
    }

    if (
      type == 'Our Entity Management' &&
      this.router.url.indexOf('OurEntityManagement') == -1
    ) {
      this.__bIsPopUpLoadingVisible = true;
    }

    if (
      type == 'Cube Explorer' &&
      this.router.url.indexOf('CubeExplorer') == -1
    ) {
      this.__bIsPopUpLoadingVisible = true;
    }

    if (
      type == 'Portfolio Management' &&
      this.router.url.indexOf('PortfolioManagement') == -1
    ) {
      this.__bIsPopUpLoadingVisible = true;
    }

    if (
      type == 'Rules Engine' &&
      this.router.url.indexOf('RulesEngine') == -1
    ) {
      this.__bIsPopUpLoadingVisible = true;
    }

    if (type == 'Data Search' && this.router.url.indexOf('DataSearch') == -1) {
      this.__bIsPopUpLoadingVisible = true;
    }

    if (type == 'Workflow Inbox' && this.router.url.indexOf('Inbox') == -1) {
      this.__bIsPopUpLoadingVisible = true;
    }

    if (
      type == 'Policy Management' &&
      this.router.url.indexOf('PolicyManagement') == -1
    ) {
      this.__bIsPopUpLoadingVisible = true;
    }

    if (
      type == 'Customer Underwriting' &&
      this.router.url.indexOf('PolicyCustomerLimitAssesment') == -1
    ) {
      this.__bIsPopUpLoadingVisible = true;
    }

    if (
      type == 'Credit Facility Management' &&
      this.router.url.indexOf('CreditFacilityManagement') == -1
    ) {
      this.__bIsPopUpLoadingVisible = true;
    }

    if (
      type == 'Position Limit' &&
      this.router.url.indexOf('PositionLimit') == -1
    ) {
      this.__bIsPopUpLoadingVisible = true;
    }
    //if (
    //  type == 'Custom View' &&
    //  this.router.url.indexOf('CustomView') == -1
    //) {
    //  this.__bIsPopUpLoadingVisible = true;
    //}

    //$('#portalMenu').removeClass('collapse in').addClass('collapse');
  }

  //changeTheme(event) {
  //   if (this.currentTheme === 'blue') {
  //     this.document.getElementById('theme').href = './StyleSheets/DashBoardManagement/BlueTheme.css';
  //     this.currentTheme = 'dark';
  //   } else {
  //     this.document.getElementById('theme').href = './StyleSheets/DashBoardManagement/DarkTheme.css';
  //     this.currentTheme = 'blue';
  //   }
  // }

  //Save user session data method handler
  SaveUserSessionData(apiUrl: string) {
    this._postDataService
      .UpdateAllDataByPromise('', this.getApiUrl + apiUrl)
      .then((result) => {
        this.OnUserSessionSuccessSave(result);
        if (result != null) {
          if (result.error != null) {
          }
        }
      })
      .catch((error) => {
        this.OnUserSessionError(error);
      });
  }

  //User session success method handler
  OnUserSessionSuccessSave(result: any) { }

  //User session error method handler
  OnUserSessionError(error: any) { }

  //style CSS applying on condition basis
  styleClass(color: string): Object {
    let CSSObject: any = {
      'pointer-events': 'unset',
      'background-color': '#1D1B3C',
    };
    if (
      !this.__oUtilityService.IsNullOrUndefined(color) &&
      !this.__oUtilityService.IsNullOrEmpty(color)
    ) {
      if (this.__IsNotAuthorized) {
        CSSObject = { 'pointer-events': 'none', 'background-color': color };
      } else {
        CSSObject = { 'pointer-events': 'unset', 'background-color': color };
      }
    }

    return CSSObject;
  }

  //Start, FB 24760 Sankar Dhayanithi T., Idle Timeout and redirecting the user to login screen.
  __oCountDownDate: any;
  __oTimeout: any;
  __oIdleTimeout: any;
  //__bReLogin: boolean = false;
  __sRedirectURL: string = '';
  __CountDownTimer: ReturnType<typeof setInterval>;
  __TimeoutTracker: any;
  __EventHandler: any;
  IdleTimeOutOperation() {
    this._postDataService
      .getDataByPromise(
        this.getApiUrl + 'api/PortalMenu/IdleTimeOutAndRedirectURL'
      )
      .then((oIdleTimeOutAndRedirectURL) => {
        if (oIdleTimeOutAndRedirectURL != null) {
          this.__oTimeout = oIdleTimeOutAndRedirectURL.MaxIdleTime;
          if (this.__oTimeout != 0) {
            this.__oIdleTimeout =
              oIdleTimeOutAndRedirectURL.MaxIdleTime -
              oIdleTimeOutAndRedirectURL.IdleTimeWarning;
            this.__oCountDownDate = new Date().getTime();
            this.__oCountDownDate +=
              oIdleTimeOutAndRedirectURL.MaxIdleTime * 60 * 1000;
            this.__sRedirectURL = oIdleTimeOutAndRedirectURL.RedirectURL;
            this.__EventHandler = this.ExtendTheIdelTimeOut.bind(this);

            window.addEventListener('mousemove', this.__EventHandler);
            window.addEventListener('scroll', this.__EventHandler);
            window.addEventListener('keydown', this.__EventHandler);

            //this.__oIdleTimer = new IdleTimer({
            //  oTimeout: (oIdleTimeOutAndRedirectURL.MaxIdleTime
            //    - oIdleTimeOutAndRedirectURL.IdleTimeWarning),
            //  onTimeoutEvent: () => {
            //    //alert(this.__IdleState);
            //    //this.SetCountDownTimer();
            //    //this.CountDownTimer();
            //    this.__TimedOut = true;
            //  }
            //  //,
            //  //onCountTimerEvent: () => {
            //  //  this.SetCountDownTimer();
            //  //}
            //});
            //this.__CountDownTimer = setInterval(function () {
            //  this.SetCountDownTimer();
            //  }, 30);
            this.ExtendTheIdelTimeOut();
            //this.__CountDownTimer = this.SetInterval(this.__oCountDownDate);
          }
        }
      });
  }
  ExtendTheIdelTimeOut() {
    if (this.__TimeoutTracker) {
      clearTimeout(this.__TimeoutTracker);
    }
    this.__TimeoutTracker = setTimeout(() => {
      sessionStorage.setItem(
        '_IdleTimeOut',
        (Date.now() + this.__oIdleTimeout * 60 * 1000).toString()
      );
    }, 30);
    this.ClearCountDownTimer();
    this.__CountDownTimer = this.SetInterval(this.__oCountDownDate);
  }
  SetInterval(oCountDownDate: any) {
    return setInterval(function () {
      //this.SetCountDownTimer();
      //SetCountDownTimer() {
      if (typeof oCountDownDate != undefined) {
        var oNowTime = new Date().getTime();
        var distance = oCountDownDate - oNowTime;

        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        document.getElementById('spIdleState').innerText =
          ('00' + minutes).slice(-2) + ':' + ('00' + seconds).slice(-2);
        //(minutes < 10 ? "0" : "") + minutes
        //  + ":" + (seconds < 10 ? "0" : "") +seconds;
        //this.__IdleState = minutes + ":" + seconds;

        if (distance < 0) {
          //this.ClearCountDownTimer();
          //this.__oIdleTimer.ClearInterval();
          document.getElementById('dvStaySignedIn').style.display = 'none';
          document.getElementById('dvReLogin').style.display = 'block';
          document.getElementById('dvStaySignedInModal').style.display = 'none';
          document.getElementById('dvReLoginModal').style.display = 'block';

          window.removeEventListener('mousemove', this.__EventHandler);
          window.removeEventListener('scroll', this.__EventHandler);
          window.removeEventListener('keydown', this.__EventHandler);
          try {
            clearInterval(this.__CountDownTimer);
          } catch { }
          //this.__bReLogin = true;
        }
        if (document.getElementById('TimeOutPopup').style.display != 'block') {
          const expiredTime = parseInt(
            sessionStorage.getItem('_IdleTimeOut'),
            10
          );
          if (expiredTime < Date.now()) {
            document.getElementById('TimeOutPopup').style.display = 'block';
          }
        }
      }
      //}
    }, 300);
  }
  ReLogin() {
    let sUrl = '';
    document.getElementById('TimeOutPopup').style.display = 'none';
    if (this.__sRedirectURL != '') sUrl = this.__sRedirectURL;
    else {
      sUrl = window.location.origin + window.location.pathname + '#/';
    }
    window.location.href = sUrl;
  }
  SignOut() {
    //this.__TimedOut = false;
    document.getElementById('TimeOutPopup').style.display = 'none';
    window.close();
  }
  StaySignedIn() {
    //this.__TimedOut = false;
    document.getElementById('TimeOutPopup').style.display = 'none';
    this.__oCountDownDate = new Date().getTime();
    this.__oCountDownDate += this.__oTimeout * 60 * 1000;
    this.ExtendTheIdelTimeOut();
    //this.__oIdleTimer.StartInterval();
  }
  ClearCountDownTimer() {
    if (this.__CountDownTimer) {
      clearInterval(this.__CountDownTimer);
    }
  }
  //End, FB 24760 Sankar Dhayanithi T., Idle Timeout and redirecting the user to login screen.

  toggleMenu() {
    this.__bMenu = !this.__bMenu;
    this.__sSelectedItem = this.__sBreadCrumbs
      .split('>')
    [this.__sBreadCrumbs.split('>').length - 1].trim();

    $('#portalMenu').show();

    this.__oTrvMenuPane.instance.collapseAll();
    if (this.__bMenu) {
      let key = 0;
      const __self = this;
      this.__lHierarchicalMenuData.forEach(function iter(a) {
        if (
          a.DashBoardPortalMenu.trim().toLocaleLowerCase() ==
          __self.__sSelectedItem.trim().toLocaleLowerCase()
        ) {
          key = a.lDashBoardPortalMenuId;
        }
        Array.isArray(a.dashBoardPortalMenuParentChildViews) &&
          a.dashBoardPortalMenuParentChildViews.forEach(iter);
      });
      this.__oTrvMenuPane.instance._refresh();
      this.__oTrvMenuPane.instance.expandItem(key);

      this.__oTrvMenuPane.instance.scrollToItem(key);
    }
  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent,matches:any[] =[]): void {
    try {
      this.__bUserPreferencesMenu = false;
      this.__bMenu = false;
      if (event instanceof NavigationEnd) {
        if (event.urlAfterRedirects.indexOf('AccessDenied') >= 0) {
          this.__bIsPopUpLoadingVisible = false;
          this.__sBreadCrumbs = 'Unauthorized';
        }
      }
      this.__oTrvMenuPane.instance.collapseAll();
      let __self = this;
      if (event instanceof NavigationStart) {
        if (!this.__oUtilityService.IsNullOrUndefined(event.url)) {
          if (event.url.indexOf('UnAuthorized') >= 0) {
            this.__sBreadCrumbs = 'Unauthorized';
            return;
          }
          //Once entered into counterparty management again we are redirecting to reference route URL causing business process managment as BreadCrumbs
          let queryParam: any =
            event.url.indexOf('CounterpartyManagement/9') >= 0
              ? '9'
              : event.url.split('/')[event.url.split('/').length - 1];
          let menuId = 0;

          if (event.url.indexOf('SuretyDashboard') < 0) {
            if (!isNaN(parseInt(queryParam)) && queryParam == parseInt(queryParam)) {
              menuId = parseInt(queryParam);
            }
            else {
              queryParam = queryParam.indexOf('Business%20Process%20Management') >= 0 ? this.__oUtilityService.URLDecode(queryParam) : queryParam;
              this.__lHierarchicalMenuData.forEach(function iter(a) {
                if (
                  !__self.__oUtilityService.IsNullOrEmpty(a.QueryString) &&
                  a.QueryString.trim().toLocaleLowerCase() ==
                  queryParam.trim().toLocaleLowerCase()
                ) {
                  menuId = a.lDashBoardPortalMenuId;
                }
                Array.isArray(a.dashBoardPortalMenuParentChildViews) &&
                  a.dashBoardPortalMenuParentChildViews.forEach(iter);
              });
            }
          }
          else { //For SuretyDashboard
            menuId = 0;
          }
          let oPortalMenu: PortalMenu = new PortalMenu();
          oPortalMenu.lDashBoardPortalMenuId = menuId;

          if (matches.length > 0) {
            oPortalMenu.lDashBoardPortalMenuId = menuId = matches[0].lDashBoardPortalMenuId;
          }

          if (oPortalMenu.lDashBoardPortalMenuId > 0) {
            this.updateBreadCrums(oPortalMenu);
          }
          //For DataSearch/add new navigations
          if (oPortalMenu.lDashBoardPortalMenuId == 0) {
            this.data.__oCurrentHeader.subscribe((x) => {
              let headerTitle: any = { header: '' };
              headerTitle = x;
              if (
                this.__oUtilityService.IsNullOrUndefined(headerTitle.header)
              ) {
                this.__sBreadCrumbs = '';
              }
              if (
                !this.__oUtilityService.IsNullOrUndefined(headerTitle.header)
              ) {
                this.__sBreadCrumbs = headerTitle.header + '> ';
              }
              switch (event.url.split('/')[1]) {
                case 'CallMemo':
                  this.__sBreadCrumbs =
                    this.__sBreadCrumbs + 'Margin Call Management';
                  break;
                case 'TradeNettingContract':
                  this.__sBreadCrumbs =
                    this.__sBreadCrumbs + 'Netting Contract Management';
                  break;
                case 'CreditSupportAnnex':
                  this.__sBreadCrumbs =
                    this.__sBreadCrumbs + 'Credit Support Annex';
                  break;
                case 'NettingContractClause':
                  this.__sBreadCrumbs =
                    this.__sBreadCrumbs + 'Contract Clause Management';
                  break;
                case 'CashManagement':
                  this.__sBreadCrumbs = this.__sBreadCrumbs + 'Cash Management';
                  break;
                case 'LetterOfCredit':
                  this.__sBreadCrumbs = this.__sBreadCrumbs + 'LC Management';
                  break;
                case 'CreditInsurance':
                  this.__sBreadCrumbs =
                    this.__sBreadCrumbs + 'Credit Insurance';
                  break;
                case 'CustomerGuarantee':
                  this.__sBreadCrumbs =
                    this.__sBreadCrumbs + 'Guarantee Management';
                  break;
                case 'TradingCounterparty':
                  this.__sBreadCrumbs =
                    this.__sBreadCrumbs + 'Trading Counterparty';
                  break;
                case 'AddCounterparty':
                  this.__sBreadCrumbs = 'Add New Instance';
                  break;
                case 'PositionLimit':
                  this.__sBreadCrumbs = 'Position Limit Dashboard';
                  break;
                case 'ScenarioDetail':
                  this.__sBreadCrumbs = this.__sScenarioDetail;
                  break;
                case 'DocumentTemplateMangement':
                  this.__sBreadCrumbs = 'Document Template Mangement';
                  break;
                default:
                  this.__sBreadCrumbs = event.url.split('/')[1];
                  if (this.__sBreadCrumbs.length > 50) {
                    this.__sBreadCrumbs = this.__sBreadCrumbs.split('?')[0];
                    switch (this.__sBreadCrumbs) {
                      case 'CallMemo':
                        this.__sBreadCrumbs = this.__sMarginCallManagement;
                        break;
                      default:
                        this.__sBreadCrumbs = '';
                        break;
                    }
                  }
                  break;
              }
            });
          }
        }
      }
      else if (matches.length > 0) {
        this.updateBreadCrums(matches[0]);
        this.__sBreadCrumbs = matches[0].DashBoardPortalMenu;
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'navigationInterceptor CP management');
    }
  }

  findMenusByQueryString(menus: any[],targetQueryString: string): any[] {
    let results: any[] = [];
    if (menus.length === 0) {
      const storedMenus = sessionStorage.getItem("MenuStorage");
      if (storedMenus) {
        menus = JSON.parse(storedMenus); // ✅ Parse string into array
      }
    }
  for (const menu of menus) {
    if (
      menu.QueryString &&
      menu.QueryString.trim().toLowerCase() === targetQueryString?.replace(/^\/+/, "").trim().toLowerCase()
    ) {
      results.push(menu);
      return results;
    }

    if (menu.dashBoardPortalMenuParentChildViews?.length) {
      results.push(
        ...this.findMenusByQueryString(menu.dashBoardPortalMenuParentChildViews, targetQueryString)
      );
    }
  }
  return results;
}

  //Menu style class, dynamic way to apply the color
  menuStyleClass(color: string) {
    let CSSObject: any = {};
    if (
      !this.__oUtilityService.IsNullOrUndefined(color) &&
      !this.__oUtilityService.IsNullOrEmpty(color) &&
      this.__bMenu
    ) {
      CSSObject = { color: color };
    }
    return CSSObject;
  }

  //Treeview contentready event handler
  onContentReady(e: any) {
    const scrollWidget = dxScrollable.getInstance(
      e.element.querySelector('.dx-scrollable')
    );
    scrollWidget.option('showScrollbar', 'always');
  }

  //Menu style class, dynamic way to apply the color
  accountStyleClass(color: string) {
    let CSSObject: any = {};
    if (
      !this.__oUtilityService.IsNullOrUndefined(color) &&
      !this.__oUtilityService.IsNullOrEmpty(color) &&
      this.__bUserPreferencesMenu
    ) {
      CSSObject = { color: color };
    }
    return CSSObject;
  }

  // Schedule Workflow

  InitializeNotification(e: any) {
    this.__oNotificationComponent = e;
  }

  getIdentityClientId(): string {
    if (environment.webapiendpoint.toString() != 'dev') {
      console.log(this.document.location.origin);
      return (
        this.document.location.origin
          .replaceAll('http://', '')
          .replaceAll('https://', '')
          .replaceAll('www.', '')
          .replaceAll('.com', '')
          .replaceAll(':', '_')
          .replaceAll('.', '_') + '_RiskCubedAuthServer'
      );
    } else {
      //dev endpoint
      return 'ROP_RiskCubedAuthServer';
    }
  }


}
